import './Navbar.css';
import Logo from '../images/logo.png'
function nav() {
  return (
<nav className="navbar navbar-expand-md navbar-dark fixed-top bg-dark" aria-label="Fourth navbar example">
<div className="container">
  <a className="navbar-brand" href="#"> <img src={Logo}/></a>
  <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarsExample04" aria-controls="navbarsExample04" aria-expanded="false" aria-label="Toggle navigation">
    <span className="navbar-toggler-icon"></span>
  </button>

  <div className="collapse navbar-collapse" id="navbarsExample04">
    <ul className="navbar-nav me-auto mb-2 mb-md-0">
      <li className="nav-item">
        <a className="nav-link active" aria-current="page" href="#">About</a>
      </li>
      <li className="nav-item">
        <a className="nav-link active" aria-current="page" href="#">Roadmap</a>
      </li>
      <li className="nav-item">
        <a className="nav-link active" aria-current="page" href="#">FAQ22</a>
      </li>
    </ul>
    <ul className="navbar-nav">
        <li className="nav-item">
          <a className="nav-link active" href="#"><i className="fab fa-twitter"></i></a>
        </li>
        <li className="nav-item">
            <a className="nav-link active" href="#"><i className="fab fa-discord"></i></a>
        </li>
        <li className="nav-item">
            <a className="nav-link active" href="#">OpenSea</a>
        </li>
      </ul>
  </div>
</div>
</nav>
  );
}

export default nav;
